import { CornerInfoComponent } from './corner-info.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    CornerInfoComponent,

  ],
  imports: [CommonModule],
  exports: [
    CornerInfoComponent,

  ],
})
export class CornerInfoModule {}
